<template>
  <div v-if="!currentMenu.isShow">
    <section
      class="common-header"
      :class="
        userData.isAndroid
          ? 'padding-nevigate-bar-ANDROID'
          : 'padding-nevigate-bar-IOS'
      "
      v-if="userData.channel != 'WEB'"
    >
      <div class="row no-gutters">
        <!-- style="margin-right: 0px; !important" -->
        <div class="col-2 pl-2 justify-content-center align-self-center">
          <div
            class=""
            v-if="currentMenu.previousPage != ''"
            @click="openModalShowBackStep2()"
          >
            <b-icon
              class="text-kanit-color-black"
              icon="chevron-left"
              style="width: 24px; height: 24px"
            />
          </div>
        </div>
        <div v-if="currentMenu.previousPage == ''" class="col-8">
          <div class="text-header-center">
            {{ currentMenu.pageName }}
          </div>
        </div>
        <template v-else>
          <div class="col-8 justify-content-center align-self-center">
            <div class="text-header-center">
              {{ currentMenu.pageName }}
            </div>
          </div>
          <div class="col-2"></div>
        </template>

        <div
          class="col-2 d-flex justify-content-center align-self-center"
          v-if="currentMenu.previousPage == ''"
          @click="openModalShowBackStep()"
        >
          <b-img
            width="24"
            height="24"
            style="cursor: pointer"
            :src="imgSystemClose"
          ></b-img>
        </div>
      </div>
    </section>


    <b-modal
      v-model="modalShowBackStep"
      hide-header
      hide-header-close
      hide-footer
      content-class="content-dialog-back"
    >
      <div class="justify-content-center py-4">
        <b-row>
          <b-col style="text-align: center"
            ><span class="font-kanit-bold-20 text-kanit-color-black"
              >ยกเลิกการอัปโหลดเอกสาร?</span
            ></b-col
          >
        </b-row>
        <b-row class="pt-2">
          <b-col style="text-align: center">
            <span class="font-kanit-regular-16 text-kanit-color-black"
              >หากยกเลิก ข้อมูลของคุณจะไม่ถูกบันทึก
              และต้องเลือกเอกสารใหม่อีกครั้ง</span
            ></b-col
          >
        </b-row>

        <b-row class="pt-4">
          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
              @click="closeModalShowBackStep()"
            >
              <span class="">ไม่ใช่</span>
            </b-button>
          </b-col>

          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-confirm-file-duplication"
              @click="goToExitEntryPoint()"
            >
              <span class="">ใช่</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="modalShowBackStep2"
      hide-header
      hide-header-close
      hide-footer
      content-class="content-dialog-back"
    >
      <div class="justify-content-center py-4">
        <b-row>
          <b-col style="text-align: center"
            ><span class="font-kanit-bold-20 text-kanit-color-black"
              >ยืนยันการออกจากหน้านี้?</span
            ></b-col
          >
        </b-row>
        <b-row class="pt-2">
          <b-col style="text-align: center">
            <span class="font-kanit-regular-16 text-kanit-color-black"
              >ข้อมูลของคุณจะไม่ถูกบันทึก</span
            ></b-col
          >
        </b-row>

        <b-row class="pt-4">
          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
              @click="closeModalShowBackStep2()"
            >
              <span class="">ยกเลิก</span>
            </b-button>
          </b-col>

          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-confirm-file-duplication"
              @click="goToPreviousPage()"
            >
              <span class="">ออกจากหน้านี้</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    step() {
      let step = -1;
      if (this.$route.name.includes("Login")) step = 0;
      else if (this.$route.name.includes("Main")) step = 1;
      else if (
        this.$route.name.includes("Upload") ||
        this.$route.name.includes("ListAccountPage") ||
        this.$route.name.includes("DstatementPage") ||
        this.$route.name.includes("DocumentGroupPage")
      )
        step = 2;
      else if (this.$route.name.includes("Summary")) step = 3;
      return step;
    },
  },
  mounted() {
    this.$event.$on("update_current_menu", (data) => {
      this.currentMenu = data;
    });
  },

  data() {
    return {
      currentMenu: {},
      modalShowBackStep: false,
      modalShowBackStep2: false,
      imgSystemClose: require("@/assets/images/ic_close.png"),
      iconBack: require("@/assets/images/Back Arrow Icon.png"),
    };
  },

  methods: {
    goToPreviousPage() {

      let param = this.currentMenu.params;
      if (param != undefined && param.grpId != undefined) {
        this.$router.push({
          name: this.currentMenu.previousPage,
          params: { grpId: param.grpId },
        });
      } else {
        this.$router.push({
          name: this.currentMenu.previousPage,
        });
      }
      this.closeModalShowBackStep2();
    },
    goToExitEntryPoint() {
      this.modalShowBackStep = false;
      try {
        this.$callback.openLfmStatusPage();
      } catch (err) {
        console.error(err);
      }
    },
    openModalShowBackStep() {
      this.modalShowBackStep = true;
    },
    closeModalShowBackStep() {
      this.modalShowBackStep = false;
    },
    openModalShowBackStep2() {
      this.modalShowBackStep2 = true;
    },
    closeModalShowBackStep2() {
      this.modalShowBackStep2 = false;
    },
  },
};
</script>
<style>
.text-color-NEXT {
  color: #5b6171 !important;
}
.border {
  border: 1px solid #8a8a8a !important;
}
.border-radius-1rem {
  border-radius: 1rem !important;
}
.bg-grey {
  background-color: #fff !important;
}
.text-label {
  color: #727a8d !important;
}
.card-body {
  color: #2f2f2f !important;
}
.badge-info {
  color: #fff;
  background-color: #1ba2de;
}
.b-card-haeder {
  font-weight: bolder;
  font-size: 1rem;
}
</style>
<style scoped>

.text-header-center {
  text-align: center;
  font-size: 20px;
  color: #212121 !important;
  font-family: Kanit-Bold;
  /* padding-left: 30%; */
}

.icon-back {
  color: #00a7ec;
}
.btn-back-step {
  width: inherit;
  color: #00a3e4;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: unset;
}
</style>
